import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ISystem } from 'src/app/domain/registration/models/ISystem';
import { DynamicFormComponent } from 'src/app/shared/components/dynamic-form/containers/dynamic-form/dynamic-form.component';
import { SystemService } from '../../systems/crud-service';
import { CES_CONFIG_FIELDS } from '../crud-config';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IPartner } from 'src/app/domain/registration/models/IPartner';
import { PartnerService } from '../../partners/crud-service';
import { PermissionService } from 'src/app/shared/permission.service';
import { ICustomerAcess } from 'src/app/domain/registration/models/ICustomerAcesss';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { ICustomer } from 'src/app/domain/customer/ICustomer';
import { CustomerService } from '../../customers/crud-service';
import { CustomerAcessService } from '../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import { MethodPaymentAccessTypeEnum } from 'src/app/domain/registration/enums/method-payment-acess-type.enum';

@Component({
  selector: 'app-customer_acess-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.sass'],
  providers: [SystemService, PartnerService],
})
export class CustomerAcessCESComponent implements OnInit, OnDestroy {
  systemSelected: ISystem;
  customerAcess() {
    throw new Error('Method not implemented.');
  }
  i: any;
  showInfo(arg0: any, arg1: any) {
    throw new Error('Method not implemented.');
  }
  form: FormGroup;
  config: IFieldConfig[] = CES_CONFIG_FIELDS;
  data: ICustomerAcess;
  typeCes: TypeCesEnum;
  title = '--';
  typeSub: Subscription | undefined;
  partnerSub: Subscription | undefined;
  element: any;
  partnersSelected: any = [];
  customersSelected: any = [];

  // Flag para controlar visibilidade do campo pixKey
  showPixKeyField: boolean = false;

  get typeCesEnum() {
    return TypeCesEnum;
  }

  setFields() {
    this.form.patchValue(this.data);

    this.typeSub = this.form
      .get('type')
      ?.valueChanges.subscribe((value: any) => {
        this.form.get('system')?.setValue('');
        this.getFieldConfig('system').componentData = {
          params: { type: SystemTypeIdEnum[value] },
        };
      });
  }

  constructor(
    public dialogRef: MatDialogRef<CustomerAcessCESComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: { type: TypeCesEnum; element: ICustomerAcess },
    private cdr: ChangeDetectorRef,
    private systemService: SystemService,
    private partnerService: PartnerService,
    private customerAcessService: CustomerAcessService,
    private toastService: ToastService,
    private fb: FormBuilder,
    public permissionService: PermissionService,
    public authService: AuthService
  ) {
    this.typeCes = data.type;
    this.data = data.element;
    this.title = this.typeCes;
  }

  ngOnInit(): void {
    this.form = this.createGroup();
    this.setFields();

    const partner = this.authService.getPartner();
    const partnerId = partner ? partner.id : null;

    console.log('ID do parceiro logado:', partnerId);

    if (partnerId) {
      this.form.patchValue({ partner_id: partnerId });
    }

    // Inicializa os dados do cliente se fornecidos
    if (this.data && this.data.customers) {
      this.customersSelected = Array.isArray(this.data.customers)
        ? this.data.customers.map((id: string) => ({ id }))
        : [{ id: this.data.customers }];

      this.form.patchValue({
        customers: this.customersSelected.map((c: { id: string }) => c.id),
      });
    }

    this.form.get('paymentMethod')?.valueChanges.subscribe((value) => {
      this.handlePaymentMethodChange(value);
    });

    // Inicializa a visibilidade do campo PIX com base no valor inicial
    this.handlePaymentMethodChange(this.form.get('paymentMethod')?.value);
  }

  public get controls() {
    return this.config
      .filter(({ type }) => type !== 'button')
      .map((control) => {
        if (this.typeCes === TypeCesEnum.SHOW) {
          control.disabled = true;
        } else {
          control.disabled = false;
        }

        return control;
      });
  }

  public createGroup() {
    const group = this.fb.group({});
    this.controls.forEach((control) =>
      group.addControl(control.name, this.createControl(control))
    );

    // Verifique se há controle para partners e ajuste caso necessário
    if (!group.get('partners')) {
      group.addControl('partners', this.fb.control([]));
    }

    group.addControl('partner_id', this.fb.control(null));

    if (!group.get('customers')) {
      group.addControl('customers', this.fb.control([]));
    }

    // Adiciona controle para paymentMethod e pixKey
    if (!group.get('paymentMethod')) {
      group.addControl('paymentMethod', this.fb.control(null));
    }
    if (!group.get('pixKey')) {
      group.addControl('pixKey', this.fb.control(null));
    }

    return group;
  }

  public createControl(config: IFieldConfig) {
    const { disabled, validation, value } = config;
    return this.fb.control({ disabled, value }, validation);
  }

  public getFieldConfig(name: string): any {
    return this.config?.find((c: any) => c.name === name);
  }

  ngOnDestroy(): void {
    this.typeSub?.unsubscribe();
  }

  ngAfterViewInit() {
    this.setFields();
    this.cdr.detectChanges();
  }

  onSubmit(value: any) {
    const partner = this.authService.getPartner();
    value['partner_id'] = partner ? partner.id : null;
    value['createdAt'] = new Date().toISOString();

    console.log('Dados iniciais:', value);

    this.systemService
      .listAll({ limit: 1000, page: 0, filter: '' })
      .subscribe(([data, length]: any) => {
        value['system'] = data.find(
          (item: ISystem) => item.name == value['system']
        );
        value['type'] = SystemTypeIdEnum[value['type']];
        value['partners'] =
          this.partnersSelected?.map((partner: IPartner) => partner.id) ?? [];

        value['systemId'] = value['system'].id;
        value['system'] = value['system'].name;

        value['customers'] =
          this.customersSelected?.length > 0
            ? this.customersSelected.map(
                (customer: { id: string }) => customer.id
              )
            : this.data?.customers ?? [];

        console.log('Dados processados:', value);

        // Envia os dados para o backend
        this.customerAcessService.create(value).subscribe(
          (response: any) => {
            console.log('Acesso criado com sucesso:', response);
            this.toastService.showSuccess(MessagesEnum.SUCCESS_CREATED);
            this.dialogRef.close({ element: value, result: true });
          },
          (error: any) => {
            console.error('Erro ao criar acesso:', error);
            this.toastService.showError(MessagesEnum.ERROR_TO_CREATE);
          }
        );
      });
  }

  onCancel() {
    this.dialogRef.close();
  }

  changeType(type: TypeCesEnum) {
    this.typeCes = type;
    this.dialogRef.close({ changeType: type });
  }

  delete() {
    this.dialogRef.close({ delete: true });
  }

  selectPartners(event: any) {
    if (event && event.length > 0) {
      this.partnersSelected = event.map((partner: any) => ({
        id: partner.id,
        name: partner.name,
      }));
    } else {
      this.partnersSelected = [];
    }

    console.log(
      'IDs dos parceiros selecionados:',
      this.partnersSelected.map((p: { id: any }) => p.id)
    );
  }

  selectCustomers(event: any) {
    if (event && event.length > 0) {
      this.customersSelected = event.map((customer: any) => ({
        id: customer.id,
        name: customer.name,
      }));
    } else {
      this.customersSelected = [];
    }

    console.log(
      'IDs dos clientes selecionados:',
      this.customersSelected.map((p: { id: any }) => p.id)
    );
  }

  // Método para lidar com a mudança no método de pagamento
  handlePaymentMethodChange(paymentMethod: string | null): void {
    const pixKeyControl = this.form.get('pixKey');

    // Exibe o campo pixKey para PIX, EMAIL, TELEFONE e CHAVE_ALEATORIA
    const showPixKeyMethods = [
      MethodPaymentAccessTypeEnum.PIX,
      MethodPaymentAccessTypeEnum.EMAIL,
      MethodPaymentAccessTypeEnum.TELEFONE,
      MethodPaymentAccessTypeEnum.CHAVE_ALEATORIA,
    ];

    if (
      showPixKeyMethods.includes(paymentMethod as MethodPaymentAccessTypeEnum)
    ) {
      this.showPixKeyField = true;
      // Opcional: Adicionar validação de obrigatório para pixKey
      // pixKeyControl?.setValidators([Validators.required]);
    } else {
      this.showPixKeyField = false;
      pixKeyControl?.setValue(null); // Limpa o valor se não for um dos métodos que requer chave
      // Opcional: Remover validação de obrigatório
      // pixKeyControl?.clearValidators();
    }
    pixKeyControl?.updateValueAndValidity();
  }
}
